var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniqCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55101 0C6.02045 0 5.51163 0.210764 5.13646 0.585924L2.23336 3.48903C2.10315 3.61924 2.10315 3.83034 2.23336 3.96055L8.03945 9.76665C8.16966 9.89685 8.38076 9.89685 8.51097 9.76665L11.4141 6.86353C11.7892 6.48837 12 5.97955 12 5.44899V1.33365C12 0.597094 11.4029 0 10.6664 0H6.55101ZM9.33259 3.33411C9.33259 3.70239 9.03404 4.00094 8.66576 4.00094C8.29749 4.00094 7.99894 3.70239 7.99894 3.33411C7.99894 2.96584 8.29749 2.66729 8.66576 2.66729C9.03404 2.66729 9.33259 2.96584 9.33259 3.33411Z",
    fill: "#800080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09642 11.1812C7.22663 11.051 7.22663 10.8399 7.09642 10.7097L1.29033 4.90358C1.16012 4.77337 0.949016 4.77337 0.818811 4.90358L0.390616 5.33177C-0.130204 5.85259 -0.130206 6.69701 0.390616 7.21783L4.78217 11.6094C5.30299 12.1302 6.14741 12.1302 6.66823 11.6094L7.09642 11.1812Z",
    fill: "#800080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqCode);
export default __webpack_public_path__ + "static/media/uniqCode.f13068e7.svg";
export { ForwardRef as ReactComponent };